import React, { memo, useMemo } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

import type { PlayerDetailStats } from '@/features/guardian-player/components/player-detail/types';

const strings = STRINGS.guardianPlayer.playerDetail;

type StatsRowProps = {
  stats: PlayerDetailStats;
};

type StatItem = {
  key: keyof PlayerDetailStats;
  value: string;
  label: string;
};

const StatsRow = memo(function StatsRow({ stats }: StatsRowProps) {
  const styles = useStyles();
  const { scale } = useScaling();

  const items: StatItem[] = useMemo(
    () => [
      { key: 'sessions', value: stats.sessions, label: strings.stats.sessions },
      { key: 'packageLeft', value: stats.packageLeft, label: strings.stats.packageLeft },
      { key: 'upcoming', value: stats.upcoming, label: strings.stats.upcoming },
      { key: 'numberGuardian', value: stats.numberGuardian, label: strings.stats.guardians },
    ],
    [stats.sessions, stats.packageLeft, stats.upcoming, stats.numberGuardian],
  );

  return (
    <Stack direction="row" style={styles.card}>
      {items.map(item => (
        <Stack key={item.key} flex={1} align="center" gap={scale(4)} paddingY={scale(8)}>
          <Text
            variant="Font Guardian App/Heading/Heading H6 18px"
            fontSize={scale(20)}
            style={styles.value}>
            {item.value}
          </Text>
          <Text
            variant="Font Guardian App/Subtitle/Subtitle 12 Regular"
            fontSize={scale(8)}
            transform="uppercase"
            style={styles.label}>
            {item.label}
          </Text>
        </Stack>
      ))}
    </Stack>
  );
});

export default StatsRow;

const useStyles = createStyles(() => ({
  card: {},
  value: {
    color: guardianColors['Main/Main'],
  },
  label: {
    color: guardianColors['6'],
  },
}));
